export default {
	methods: {
		/**
		 * Remove os cookies
		 * @param Array value
		 **/
		clearCookies() {
			// efetua uma chamada ajax para setar o cookie como inativo
			let data = new FormData();
			data.append("class", "Login");
			data.append("method", "Logoff");
			data.append("username", this.$cookie.get('username'));

			if(typeof this.$route.query.btnclick != 'undefined'){
				data.append("btnclick", this.$route.query.btnclick);
				window.location.href = window.location.href.split('?')[0];

				this.$cookie.remove("hashlogin");
			}

			this.$helper.axios().post('', data);

			// limpa os cookies
			let cookie = this.$cookie.getAll();
			for(let ck in cookie){
				// Como o domínio é o mesmo, impede se deslogar do pb_framework
				if(ck != "PHPSESSID" && ck != "mfvalidationtoken" && ck != "language" && ck != "hashlogin"){
					this.$cookie.remove(ck);
				}
			}

			localStorage.removeItem("perm");

			this.setLanguage();

			// Quando o usuário loga, e marca a opção lembrar deste computador,
			// o sistema gera uma hash e coloca no login, para não pedir o token por um tempo
			this.hashlogin = this.$cookie.get("hashlogin");
		},

		/**
		 * Seta os cookies
		 * @param Array response
		 **/
		setCookiesLoggedIn(response) {
			this.$cookie.set('token', 			response.data.token,			{"SameSite": "None", "Secure": ""});
			this.$cookie.set('xpp', 			response.data.merchant_number,	{"SameSite": "None", "Secure": ""});
			this.$cookie.set('realxpp',			response.data.merchant_number,	{"SameSite": "None", "Secure": ""});
			this.$cookie.set('email', 			response.data.email,			{"SameSite": "None", "Secure": ""});
			this.$cookie.set('username', 		response.data.username,			{"SameSite": "None", "Secure": ""});
			this.$cookie.set('rep_format',		response.data.rep_format,		{"SameSite": "None", "Secure": ""});

			if(typeof response.data.hashlogin != "undefined"){
				let dataatual = new Date;
				dataatual.setDate(dataatual.getDate() + 15); // válido por 15 dias

				this.$cookie.set('hashlogin', response.data.hashlogin, {"SameSite": "None", "Secure": "", "expires": dataatual.toGMTString()} );
			}

			// Permissões
			this.perm = response.data.perm;
			localStorage.setItem('perm', JSON.stringify(response.data.perm));

			if(typeof response.data.language != "undefined"){
				this.$locale.change(response.data.language);
				this.$cookie.set('language', response.data.language, {"SameSite": "None", "Secure": ""});
			}
		},
		/**
		 * Seta a linguagem conforme o cookie ou o local.
		 **/
		setLanguage() {
			let browser_language = window.navigator.userLanguage || window.navigator.language;
			let language = this.$cookie.get("language");

			if(language == null || typeof language == "undefined" || language == "undefined"){
				language = "en";
				if(browser_language.toLowerCase() == "pt-br" || browser_language.toLowerCase() == "pt"){
					language = "pt";
				}
			}

			if(!this.$locale.current() || language != this.$locale.current()){
				this.$locale.change(language);
				this.$cookie.set('language', this.language, {"SameSite": "None", "Secure": ""});
			}
		},
	}
}